var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('v-select',{class:_vm.colour,attrs:{"options":_vm.options,"placeholder":_vm.placeholder},on:{"search":_vm.fetchAddressList,"input":_vm.getSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }